/**
 * The minimal top bar (Essenziale): the voice switch and the session id (tap: copy) on the left, the language and Settings on the
 * right, and in the middle whose screen this is when it is not the user's (replay, operator). Where the
 * user is in the task moves to the minimal footer.
 */
import { useApp } from '../../react/app';
import { useSession, useTranslate } from '../../react/hooks';
import { RoleLabel } from '../../shell/RoleLabel';
import { SessionChip } from '../../shell/SessionChip';
import { useUiActions } from '../../shell/useUiActions';
import { Icon } from '../../ui-kit/Icon';
import { useVoice } from '../../voice/useVoice';
import css from './Minimal.module.css';

export function MinimalTopBar() {
  const app = useApp();
  const t = useTranslate();
  const actions = useUiActions();
  const language = useSession((s) => s?.language ?? 'it');
  const microphone = useVoice((v) => v.microphone);
  const languages = app.pack.languages;
  const nextLanguage = languages[(languages.indexOf(language) + 1) % languages.length] ?? language;

  return (
    <div className={`${css.top} ${css.topGrid}`}>
      <div className={css.side}>
        <button className={css.icon} disabled={!app.voice} aria-pressed={microphone}
          aria-label={t(microphone ? 'voice.mic_on' : 'voice.mic_off')}
          onClick={() => { app.voice?.unlockAudio(); void app.voice?.setMicrophone(!microphone); }}>
          <Icon name={microphone ? 'mic' : 'mic-off'} size={34} />
        </button>
        {app.kiosk.role === 'kiosk' && <SessionChip />}
      </div>
      <span className={css.middle}><RoleLabel /></span>
      <div className={`${css.side} ${css.end}`}>
        {languages.length > 1 && (
          <button className={css.pill} onClick={() => void app.kiosk.setLanguage(nextLanguage)} aria-label={t('action.language')}>
            <Icon name="language" size={24} />{language.toUpperCase()}
          </button>
        )}
        <button className={css.icon} onClick={() => actions.toggleSettings()} aria-label={t('settings.title')}>
          <Icon name="settings" size={32} />
        </button>
      </div>
    </div>
  );
}
